import { useState, useEffect } from 'react';
import {
    AuthLogin,
    validateToken
} from '../services/AuthServices';

export const useAuth = () => {

    const [auth, setAuth] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const authPost = async (data) => {
        try {

            setLoading(true)
            const response = await AuthLogin(data);
            if (response?.data?.status == 400) {
                setError('Login Failed!!');
            }

            setLoading(false)
            return response?.data
        } catch {
            setError('Failed!!');
        }

        setLoading(false)
    };


    const validate = async () => {
        try {
            setLoading(true);
            const response = await validateToken();

            if (response?.data?.status == 400) {
                setError('Login Failed!!');
            }
            setAuth(response?.data);

            setLoading(false);

            return response?.data
        } catch {
            setError('Failed!!');
        }

        setLoading(false)
    };

    useEffect(() => {
        validate();
    }, []);

    return { loading, error, auth, authPost, validate };
};
